var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100vw","height":"100vh","overflow":"hidden"}},[_c('iframe',{attrs:{"src":_vm.pdfUrl,"width":"100%","height":"100%","frameborder":"0"},on:{"load":_vm.onIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }